import React, { createContext, useContext, useState, ReactNode } from 'react';
import en from '../locales/en.json';
import sv from '../locales/sv.json';

const translations = { en, sv };

interface LanguageContextType {
    language: 'en' | 'sv';
    setLanguage: (lang: 'en' | 'sv') => void;
    t: (key: string) => any;
}

const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

export const LanguageProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [language, setLanguage] = useState<'en' | 'sv'>(() => {
        const stored = localStorage.getItem('language');
        return stored === 'sv' ? 'sv' : 'en';
    });

    const handleSetLanguage = (lang: 'en' | 'sv') => {
        setLanguage(lang);
        localStorage.setItem('language', lang);
    };

    const getTranslation = (key: string): any => {
        const keys = key.split('.');
        let result: any = translations[language];
        
        for (const k of keys) {
            result = result?.[k];
        }
        
        return result || key;
    };

    const value = {
        language,
        setLanguage: handleSetLanguage,
        t: getTranslation
    };

    return (
        <LanguageContext.Provider value={value}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => {
    const context = useContext(LanguageContext);
    if (context === undefined) {
        throw new Error('useLanguage must be used within a LanguageProvider');
    }
    return context;
};
